<template>
  <div class="main">
    <div @click="go" class="showbox">
      <div class="content" :style="{ marginLeft: msgStyleLeft + 'px' }">
        {{ showMessage }}
      </div>
    </div>
    <div class="close" @click="close">
      <img src="../../assets/image/prompt/upgrade_close.png" />
    </div>
  </div>
</template>

<script>
import config from "../../assets/script/config/index.js";
export default {
  name: "showUpgrade",
  data() {
    return {
      msgStyleLeft: 72,
      vipUrl: config.vipUrl
    };
  },
  props: {
    showMessage: {
      type: String,
      default: "获取翻页权限"
    }
  },
  mounted() {
    if (this.showMessage === "获取更多使用次数") {
      this.msgStyleLeft = 60;
    }
  },
  methods: {
    close() {
      this.$emit("closeUpgrade", false);
    },
    go() {
      window.open(this.vipUrl + "/price");
      this.$emit("closeUpgrade", false);
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  background-color: rgba(63, 61, 61, 0.5);
  transition: opacity 0.3s;
  z-index: 10000;
  .showbox {
    cursor: pointer;
    width: 240px;
    height: 377px;
    background: url("../../assets/image/prompt/upgrade.png");
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -120px;
    margin-top: -188px;
    .content {
      margin-top: 210px;
      margin-left: 70px;
      color: #986a17;
      font-size: 16px;
      font-weight: 600;
      position: absolute;
    }
  }
  .close {
    top: 50%;
    left: 50%;
    margin-top: -125px;
    position: fixed;
    margin-left: 145px;
    cursor: pointer;
  }
}
</style>
